module.exports = __webpack_public_path__ + "static/media/bc.bac37dbd.svg";